export const isObject = (val: any) =>
  val !== null && typeof val === 'object' && !Array.isArray(val);
